import { useKeycloak } from "@react-keycloak/web";
import { Button, Input, Select } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import AddIcon from "../../../../assets/icons/AddIcon";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import ViewIcon from "../../../../assets/icons/ViewIcon";
import SearchIcon from "../../../../assets/web/icons/SearchIcon";
import CustomTable from "../../../../components/ui/CustomTable";
import {
  useGetAllAssignProjectQuery,
  useGetAllCompanyQuery,
} from "../../../../features/portal/companyOnboard/companyOnboardApi";
import useError from "../../../../hooks/useError";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatDate } from "../../../../lib/time";
import { countParPageSerialNumber } from "../../../../utils/number";
import { capitalize } from "../../../../utils/string";
import { addKeyInArray } from "../../../../utils/utils";

export default function RoleAccessList() {
  const {
    page,
    limit,
    handlePagination,
    handleLimit,
    filter,
    handleFilter,
    handleSearch,
    keyword,
  } = useTable<any>();

  const { user, role } = useAppSelector((state) => state.auth);
  const { keycloak } = useKeycloak();
  const isAdmin2 = keycloak?.realmAccess?.roles?.includes("admin2");

  const companyId = filter?.company_id ? Number(filter.company_id) : undefined;

  const {
    isError: getAllAssignProjectIsError,
    error: getAllAssignProjectError,
    isLoading: getAllAssignProjectIsLoading,
    data: getAllAssignProject,
  } = useGetAllAssignProjectQuery(
    { id: companyId as number, search: keyword },
    {
      skip: !companyId, // only run when companyId exists
    }
  );

  const {
    isError: isAllCompanyError,
    error: allCompanyError,
    data: allCompanyData,
  } = useGetAllCompanyQuery({
    params: {
      company_id: role === "SUPER_ADMIN" ? undefined : user?.data?.company_id,
      page: 1,
      limit: 1000000000000,
    },
  });

  useError(
    getAllAssignProjectIsError,
    getAllAssignProjectError,
    "Get all assign project data fail"
  );
  useError(isAllCompanyError, allCompanyError, "Get all company data fail");

  useEffect(() => {
    if (isAdmin2) {
      handleFilter("company_id", user?.data?.company_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin2, user?.data?.company_id]);

  const columns: ColumnsType<any> = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },

    {
      title: <div className="text-nowrap">Company Name</div>,
      render: () => {
        return getAllAssignProject?.data?.companyName
          ? capitalize(getAllAssignProject?.data?.companyName)
          : "N/A";
      },
    },

    {
      title: <div className="text-nowrap">Product Name</div>,
      dataIndex: "project_name",
      render: (val) => {
        return val ? val : "N/A";
      },
    },

    {
      title: <div className="text-nowrap">Created at</div>,
      dataIndex: "access_granted_at",
      align: "center",
      render: (val) => {
        return val ? formatDate(val) : "N/A";
      },
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (val: number, record: any) => {
        return (
          <div className="flex justify-center items-center gap-2">
            {/* <Button
              className="action-button"
              size="small"
              icon={<EditIcon />}
            /> */}
            <Link
              to={`/admin/users-roll-access/roll-access/product-access/${getAllAssignProject?.data?.companyId}/${record?.project_id}/${record?.project_name}/${record?.service_name}`}
            >
              <Button
                className="action-button"
                size="small"
                icon={<ViewIcon />}
              />
            </Link>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <SidebarLayout title={`User Role Access`}>
        <CustomTable
          loading={getAllAssignProjectIsLoading}
          limit={limit}
          page={page}
          columns={columns}
          total={10}
          dataSource={addKeyInArray(getAllAssignProject?.data?.projects)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              <Input
                suffix={<SearchIcon />}
                placeholder="Search by Product"
                style={{ width: 215 }}
                allowClear
                onChange={handleSearch}
              />

              <Select
                placeholder="Company Name"
                showSearch
                options={
                  allCompanyData?.data?.companies?.map((company: any) => ({
                    label: capitalize(company?.company_name),
                    value: company?.id,
                  })) || []
                }
                value={filter?.company_id ?? undefined}
                onChange={(value) => handleFilter("company_id", value)}
                className="!m-w-[210px]"
                suffixIcon={<SelectDownIcon />}
                allowClear
                disabled={isAdmin2}
                optionFilterProp="label"
              />

              <Link to="/admin/users-roll-access/roll-access/add">
                <Button
                  type="primary"
                  className="middle-button"
                  icon={<AddIcon />}
                >
                  Assign Product
                </Button>
              </Link>
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}
